export function relayPrincipalKey(accountId: string, organizationId: string): string {
  return JSON.stringify([accountId, organizationId]);
}

/** Partitions persisted relay data by authentication issuer, relay, account, and organization. */
export function relayAccountKey(input: {
  readonly publishableKey: string;
  readonly relayUrl: string;
  readonly accountId: string;
  readonly organizationId?: string | null;
}): string {
  return JSON.stringify([
    input.publishableKey,
    new URL(input.relayUrl).origin,
    input.accountId,
    input.organizationId,
  ]);
}
